export function getErrorMessage(code: number) {
  const key = `E${code}` as keyof typeof errorTitle;
  return {
    title: errorTitle[key] ?? 'Unknown error occurred.',
    message: errorText[key] ?? 'Please go back or try again',
  };
}

export enum errorTitle {
  E204 = 'No data available.',
  E400 = 'Bad Request.',
  E401 = 'Your session has expired.',
  E403 = 'Forbidden. You do not have access.',
  E404 = "Oops! Looks like the page you're looking for doesn't exist.",
  E500 = 'Internal server error.',
  E501 = 'No dealers configured',
  E0 = 'Network error.',
}

export enum errorText {
  E204 = "Looks like we couldn't find any data.",
  E400 = ' Please check your input and try again',
  E401 = 'Looks like your session has expired.',
  E403 = "You don't have permission to view this page.",
  E404 = 'Please check the URL you entered.',
  E500 = 'Please try again later.',
  E0 = ' Please check your connection and try again',
  E501 = 'No Dealers are configured for this Committee,',
}
